import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { WindowService } from '../../shared/window.service';
import { FaqService } from '../faq.service';

@Component({
  selector: 'lp2-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqPageComponent implements OnInit {
  isFromContactPage = false;

  constructor(
    public faqService: FaqService,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    this.faqService.initFaqsAndFilters();
    const params = this.windowService.getSearchParams();
    this.isFromContactPage = params.get('from') === 'talkNow';
  }
}



// WEBPACK FOOTER //
// ./ts/app/faq/faq-page/faq-page.component.ts